<template>
  <section class="table-sampler-memory-vibration">
    <d-form-row class="m-0 mb-1">
      <d-col cols="2">
        <label>Data</label>
        <input
          type="text"
          class="form-control"
          placeholder="Data"
          v-model="model.date"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N. Medição</label>
        <input
          type="text"
          class="form-control"
          placeholder="N. Medição"
          v-model="model.medition"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Horário inicial</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário inicial"
          v-model="model.initial"
          required
        />
      </d-col>
      <d-col cols>
        <label>Horário final</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário final"
          v-model="model.final"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Agente</label>
        <input
          type="text"
          class="form-control"
          placeholder="Agente"
          v-model="model.agent"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo de vibração</label>
        <select
          type="text"
          class="form-control"
          v-model="model.vibration_type"
          required
          @change="handlerVibrationType()"
        >
          <option value="Vibração de corpo inteiro">Vibração de corpo inteiro</option>
          <option value="Vibração de mãos e braços">Vibração de mãos e braços</option>
        </select>
      </d-col>
      <d-col cols="2">
        <label>Método</label>
        <select
          type="text"
          class="form-control"
          v-model="model.method"
          required
        >
          <option value="NHO 09">NHO 09</option>
          <option value="NHO 10">NHO 10</option>
        </select>
      </d-col>
      <d-col cols="2">
        <label>Critério</label>
        <select
          type="text"
          class="form-control"
          v-model="model.criterion"
          required
        >
          <option value="VDVR">VDVR</option>
          <option value="AREN">AREN</option>
          <option value="AREN/VDVR">AREN/VDVR</option>
        </select>
      </d-col>
      <d-col cols="2">
        <label></label>
        <select
          type="text"
          class="form-control"
          v-model="model.criterion_1"
          required
        >
          <option value="null"></option>
          <option value="1,1 Aren / 21 VDVR">1,1 Aren / 21 VDVR</option>
        </select>
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Instrumento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Instrumento"
          v-model="model.instrument"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.instrument_serie"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.instrument_certificate"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.instrument_validity"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="2">
        <label>Componente</label>
        <input
          type="text"
          class="form-control"
          placeholder="Componente"
          v-model="model.component"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Tempo de exposição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tempo de exposição"
          v-model="model.exposition_time"
          required
        />
      </d-col>
      <d-col cols>
        <label>Ciclo</label>
        <input
          type="text"
          class="form-control"
          placeholder="Ciclo"
          v-model="model.cycle"
          required
        />
      </d-col>
      <d-col cols>
        <label>Tempo amostrado</label>
        <input
          type="time"
          class="form-control"
          placeholder="Tempo amostrado"
          v-model="model.sample_time"
          required
        />
      </d-col>
      <d-col cols>
        <label>Número de repetições <small>(h)</small></label>
        <input
          type="number"
          class="form-control"
          placeholder="Número de repetições"
          v-model="model.repeat_number"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="4">
        <label>Fonte de vibração</label>
        <input
          type="text"
          class="form-control"
          placeholder="Fonte de vibração"
          v-model="model.vibration_font"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Frequência</label>
        <input
          type="text"
          class="form-control"
          placeholder="Frequência"
          v-model="model.frequency"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Marca</label>
        <input
          type="text"
          class="form-control"
          placeholder="Marca"
          v-model="model.brand"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Modelo</label>
        <input
          type="text"
          class="form-control"
          placeholder="Modelo"
          v-model="model.model"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Ano equipamento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Ano equipamento"
          v-model="model.equipment_year"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo do banco</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de banco"
          v-model="model.bank_type"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Tipo de pneu</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de pneu"
          v-model="model.tire_type"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo de piso</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de piso"
          v-model="model.floor_type"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Velocidade operação</label>
        <input
          type="text"
          class="form-control"
          placeholder="Velocidade operação"
          v-model="model.operating_speed"
          required
        />
      </d-col>
    </d-form-row>

    <epi-list :list.sync="model.epis"></epi-list>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Observações</label>
        <textarea
          type="text"
          class="form-control"
          placeholder="Observações"
          v-model="model.observation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import { VIBRATION_MEMORY, _LOAD_MODEL_ } from '../../SampleModel';
import EpiList from '../EPIList.vue';

export default {
  name: 'Sample-Memory-Vibration',
  props: {
    memory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(VIBRATION_MEMORY),
    };
  },
  components: {
    EpiList,
  },
  methods: {
    ...mapActions([
      'setSample',
    ]),
    setModel() {
      if (this.memory) {
        this.model = this.memory;
      }
    },
    handlerVibrationType() {
      if (this.model.vibration_type === 'corpo') {
        this.model.method = 'nho09';
        this.model.criterion = 'aren/vdvr';
        this.model.criterion_1 = 'aren/vdvr';
      } else {
        this.model.method = 'nho10';
        this.model.criterion = 'aren';
        this.model.criterion_1 = null;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.setSample({ ...this.$store.state.sample.sample, ...{ memory_field: value } });
        this.$emit('update:memory', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-memory-vibration {
  label {
    margin-bottom: 0;
  }
}
</style>
